import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconMacbook"><Path d="M22.25 17C22.6642 17 23 17.3358 23 17.75V20.25C23 20.6642 22.6642 21 22.25 21H1.75C1.33579 21 1 20.6642 1 20.25V17.75C1 17.3358 1.33579 17 1.75 17H22.25Z" fill="currentColor"/><Path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V15.5H3V3.75C3 3.33579 3.33579 3 3.75 3H20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbook;
